<template>
  <div class="footer">
    <div class="footer-container">
      <div class="footer-left">
        <img src="../../assets/logowhite.png" width="300px" />
        <p>专注少儿编程&nbsp;&nbsp;&nbsp;&nbsp;人工智能教育</p>
        <p>让孩子成为人工智能时代的领导者</p>
      </div>

      <div class="footer-middle">
        <div class="contact-us">联系我们</div>
        <p>咨询热线：020-32198727&nbsp;&nbsp;&nbsp;&nbsp;18148739211</p>
        <p>商务合作：17724002195</p>
        <p>研发中心：佛山市南海区碧桂园广佛上城11栋903-904</p>
        <div class="online-cons"  @mouseover="onmouseover" @mouseleave="onmoseout" >咨询</div>
        <div class="online-qr" v-if="isShowKefu === true">
          <img src="../../../static/images/kefu.jpg" width="160px" height="160px" style="border-radius: 10px;" />
          <p style="color: #333;font-size: 18px;">联系客服微信</p>
        </div>
        <!-- <img src="../../../static/images/qr.jpg" width="120px" height="120px" /> -->
        <p>Copyright © 2020-2021 广州哆哆科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank"
            style="color: #ffffff;"> 粤ICP备2021015478号</a></p>
      </div>
      <div class="footer-right">
        <div class="contact-us">关注我们</div>
        <div class="qr-container">
          <div class="qr-item">
            <img src="../../../static/images/qr.jpg" width="120px" height="120px" />
            <p>关注微信公众号</p>
          </div>
          <div class="qr-item">
            <img src="../../../static/images/qrdy.png" width="120px" height="120px" />
            <p>关注抖音官方号</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isShowKefu: false
    }
  },
  props: {},
  created () {},
  methods: {
    onmouseover () {
      this.isShowKefu = true
    },
    onmoseout () {
      this.isShowKefu = false
    }
  }
}

</script>

<style>
  * {
    margin: 0px;
    padding: 0px;
  }

  .footer {
    background: #423f3f;
    padding: 50px 0;
    height: 200px;
  }

  .footer-container {
    width: 1200px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;

  }

  .qr-container {
    width: 300px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .qr-item{
    width: 140px;
    text-align: center;
  }

  .online-qr{
    text-align: center;
    width: 200px;
    height: 210px;
    background-color: #ffffff;
    padding-top: 20px;
    border-radius: 10px;
    position:absolute;
    left: 250px;
    top: 0px;
  }
  .qr-item img {
    border-radius: 10px;
  }
  .qr-item p {
    color: #ffffff;
    font-size: 16px;
    margin-top: 10px;
  }
  .footer-left {
    width: 350px;
    text-align: left;
    color: #999999;
    float: left;
    font-size: 18px;
    line-height: 30px;
  }

  .contact-us {
    font-size: 20px;
    color: #fff;
    margin-bottom: 20px;
  }

  .footer-middle {
    position: relative;
    width: 600px;
    color: #999999;
    margin: 0 auto;
    font-size: 20px;
  }

  .footer-middle p {
    color: #999999;
    margin: 0 auto;
    font-size: 16px;
    margin-top: 10px;
  }

  .online-cons {
    text-align: right;
    background: #fe6b0000 url(../../../static/images/chat.png) no-repeat 36px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    width: 200px;
    height: 44px;
    line-height: 40px;
    border-radius: 22px;
    border: 2px solid #fff;
    padding-right: 50px;
    cursor: pointer;
    margin-top: 20px;
    margin-bottom: 20px;
    /* user-select: none; */
  }

  .footer-right {
    /* float: right; */
    color: rgb(94, 94, 94);
    height: 200px;
    margin-top: 0px;
    width: 200px;

  }

  .right-text {
    margin-left: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/components/bottom/Footer.vue